import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from './Navbar';
import {
  BusinessTimeZoneNote,
  BusinessTimeZoneWarning,
  CompanyTimeZoneProvider,
  useCompanyTimeZone,
} from 'reusable/CompanyTimeZone';
import SupportBanner from 'components/Support/SupportBanner';

/**
 * EV-116 段階2。業務の画面は会社の時間帯が決まってから描く。時間帯が変わったら作り直す
 * （各画面の「今日」・期間・表示が新しい時間帯で計算され、データを取り直す）。
 */
const ZonedOutlet: React.FC = () => {
  const { t } = useTranslation('common');
  const { zone, ready } = useCompanyTimeZone();
  if (!ready) {
    return (
      <div role="status" aria-busy="true" className="p-4">
        {t('ui.loading')}
      </div>
    );
  }
  return <Outlet key={zone} />;
};

const Layout: React.FC = () => {
  return (
    <CompanyTimeZoneProvider>
      <main className="flex">
        <Navbar />
        <article className="w-full h-screen bg-primary/50 overflow-y-scroll">
          {/* YAC-2026-009 PR7b。運営のサポートのセッションでは、上に常に帯を出す（それ以外では何も出さない）。 */}
          <SupportBanner />
          {/* EV-116 段階2（TZ-AC11）。一覧・集計・グラフ・CSV の日付の基準の時間帯。 */}
          <div className="flex flex-col items-end px-4 pt-2">
            <BusinessTimeZoneNote />
            {/* TZ-AC20。ブラウザが会社の時間帯を知らないときの注記（集計の基準のすぐ下）。 */}
            <BusinessTimeZoneWarning />
          </div>
          <ZonedOutlet />
        </article>
      </main>
    </CompanyTimeZoneProvider>
  );
};

export default Layout;
